import { render, staticRenderFns } from "./hpText3.vue?vue&type=template&id=f59a98ca&scoped=true&"
import script from "./hpText3.vue?vue&type=script&lang=js&"
export * from "./hpText3.vue?vue&type=script&lang=js&"
import style0 from "./hpText3.vue?vue&type=style&index=0&id=f59a98ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59a98ca",
  null
  
)

export default component.exports